"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDataComponents = require("react-data-components");

var _dataReducer = require("../../../node_modules/react-data-components/lib/dataReducer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var dataLoaded = _reactDataComponents.actions.dataLoaded,
    dataSort = _reactDataComponents.actions.dataSort,
    dataFilter = _reactDataComponents.actions.dataFilter,
    pageNumberChange = _reactDataComponents.actions.pageNumberChange,
    pageSizeChange = _reactDataComponents.actions.pageSizeChange;
var containsIgnoreCase = _reactDataComponents.utils.containsIgnoreCase;

var mapPropsToState = function mapPropsToState(props, localStorage) {
  return {
    pageSize: localStorage.pageSize || props.initialPageLength,
    sortBy: localStorage.sort || props.initialSortBy,
    pageNumber: localStorage.pageNumber || 0,
    filterValues: {
      globalSearch: localStorage.globalSearch || ''
    }
  };
};

var DataList = /*#__PURE__*/function (_React$Component) {
  _inherits(DataList, _React$Component);

  function DataList(props) {
    var _this;

    _classCallCheck(this, DataList);

    _this = _possibleConstructorReturn(this, (DataList.__proto__ || Object.getPrototypeOf(DataList)).call(this, props));
    var propsFromLocalStorage = _this.props.useLocalStorage ? _this.getValuesFromLocalStorage() : {};
    _this.state = (0, _dataReducer.dataReducer)(mapPropsToState(props, propsFromLocalStorage), dataLoaded(props.initialData));
    _this.renderControls = _this.renderControls.bind(_assertThisInitialized(_this));
    _this.setValueInLocalStorage = _this.setValueInLocalStorage.bind(_assertThisInitialized(_this));
    _this.getValueFromLocalStorage = _this.getValueFromLocalStorage.bind(_assertThisInitialized(_this));
    _this.getValuesFromLocalStorage = _this.getValuesFromLocalStorage.bind(_assertThisInitialized(_this));
    _this.getCurrentPageNumberLocalStorage = _this.getCurrentPageNumberLocalStorage.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   *
   */


  _createClass(DataList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initialize();
    }
    /**
     *
     * @param prevProps
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.initialData !== prevProps.initialData) {
        this.initialize();
      }
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "render",
    value: function render() {
      // Protect against unloaded data.
      if (!this.state) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "datalist"
      }, this.renderControls(), /*#__PURE__*/_react.default.createElement("div", {
        className: "datalist__table"
      }, /*#__PURE__*/_react.default.createElement(_reactDataComponents.Table, {
        className: 'table ' + (this.state.page.length === 0 ? 'table--no-data' : ''),
        dataArray: this.props.withControls ? this.state.page : this.props.initialData,
        columns: this.props.columns,
        keys: this.props.keys,
        sortBy: this.state.sortBy,
        buildRowOptions: this.props.buildRowOptions,
        onSort: this.props.enableSort ? this.onSort.bind(this) : null
      }), this.state.page.length === 0 && !this.props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
        className: "datalist__no-data"
      }, this.props.staticTexts.noData) : null, this.props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
        className: "datalist__loader"
      }, this.props.staticTexts.loading, /*#__PURE__*/_react.default.createElement("span", {
        className: "loader"
      })) : null), this.state.data.length > this.state.pageSize && /*#__PURE__*/_react.default.createElement("div", {
        className: "datalist__pagination"
      }, /*#__PURE__*/_react.default.createElement(_reactDataComponents.Pagination, {
        className: "pagination",
        currentPage: this.state.pageNumber,
        totalPages: this.state.totalPages,
        onChangePage: this.onPageNumberChange.bind(this)
      })));
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "renderControls",
    value: function renderControls() {
      var _this2 = this;

      if (!this.props.withControls) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "datalist__controls"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "datalist__searchfilter"
      }, this.props.showSearch && /*#__PURE__*/_react.default.createElement("label", {
        className: "input input--search"
      }, this.props.staticTexts.search, /*#__PURE__*/_react.default.createElement("span", {
        className: "input__wrapper"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "search",
        value: this.state.filterValues.globalSearch,
        onChange: this.onFilter.bind(this, 'globalSearch')
      })))), this.props.showPageSize === true ? /*#__PURE__*/_react.default.createElement("div", {
        className: "datalist__page-size"
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "select"
      }, this.props.staticTexts.pageSize, /*#__PURE__*/_react.default.createElement("span", {
        className: "select__wrapper"
      }, /*#__PURE__*/_react.default.createElement("select", {
        value: this.state.pageSize,
        onChange: this.onPageSizeChange.bind(this)
      }, this.props.pageLengthOptions.map(function (opt) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: opt,
          value: opt
        }, opt === 0 ? _this2.props.staticTexts.all : opt);
      }))))) : null);
    }
    /**
     *
     */

  }, {
    key: "initialize",
    value: function initialize() {
      var _this3 = this;

      //if (this.props.initialData.length === 0) return;
      this.setState(function (state) {
        // get filtered data
        var loadedState = (0, _dataReducer.dataReducer)(state, dataLoaded(_this3.props.initialData)); // do search on filtered data

        var searchState = (0, _dataReducer.dataReducer)(loadedState, dataFilter('globalSearch', _this3.state.filterValues.globalSearch, _this3.props.filters));
        if (!_this3.props.useLocalStorage) return searchState; // dataFilter sets pageNumber implicitly to 0 which is good in a normal case, but not in the
        // initial case

        return (0, _dataReducer.dataReducer)(searchState, pageNumberChange(_this3.getCurrentPageNumberLocalStorage()));
      });
    }
    /**
     *
     * @param value
     */

  }, {
    key: "onPageNumberChange",
    value: function onPageNumberChange(value) {
      this.setValueInLocalStorage('dataListCurrentPageNumber', value);
      this.setState(function (state) {
        return (0, _dataReducer.dataReducer)(state, pageNumberChange(value));
      });
    }
    /**
     *
     * @param value
     */

  }, {
    key: "onPageSizeChange",
    value: function onPageSizeChange(_ref) {
      var _this4 = this;

      var value = _ref.target.value;
      this.setState(function (state) {
        var newState = (0, _dataReducer.dataReducer)(state, pageSizeChange(value));

        _this4.setValueInLocalStorage('dataListCurrentPageSize', newState.pageSize);

        _this4.setValueInLocalStorage('dataListCurrentPageNumber', newState.pageNumber);

        return newState;
      });
    }
    /**
     *
     * @param value
     */

  }, {
    key: "onSort",
    value: function onSort(value) {
      this.setValueInLocalStorage('dataListCurrentSort', value);
      this.setState(function (state) {
        return (0, _dataReducer.dataReducer)(state, dataSort(value));
      });
    }
    /**
     *
     * @param key
     * @param value
     */

  }, {
    key: "onFilter",
    value: function onFilter(key, _ref2) {
      var _this5 = this;

      var value = _ref2.target.value;
      this.setState(function (state) {
        return (0, _dataReducer.dataReducer)(state, dataFilter(key, value, _this5.props.filters));
      });
      this.setValueInLocalStorage('dataListGlobalSearch', value);
      this.setValueInLocalStorage('dataListCurrentPageNumber', 0);
    }
    /**
     *
     * @param key
     * @param value
     */

  }, {
    key: "setValueInLocalStorage",
    value: function setValueInLocalStorage(key, value) {
      if (!this.props.useLocalStorage) return;
      localStorage.setItem(key, value);
    }
    /**
     *
     * @param key
     * @returns {string}
     */

  }, {
    key: "getValueFromLocalStorage",
    value: function getValueFromLocalStorage(key) {
      return localStorage.getItem(key);
    }
    /**
     *
     * @returns {number|number}
     */

  }, {
    key: "getCurrentPageNumberLocalStorage",
    value: function getCurrentPageNumberLocalStorage() {
      var currentPageNumber = parseInt(this.getValueFromLocalStorage('dataListCurrentPageNumber'));
      return !isNaN(currentPageNumber) ? currentPageNumber : 0;
    }
    /**
     *
     * @returns {{pageNumber: number, pageSize: number, globalSearch: string, sort: string}}
     */

  }, {
    key: "getValuesFromLocalStorage",
    value: function getValuesFromLocalStorage() {
      return {
        pageNumber: this.getCurrentPageNumberLocalStorage(),
        pageSize: parseInt(this.getValueFromLocalStorage('dataListCurrentPageSize')),
        sort: this.getValueFromLocalStorage('dataListCurrentSort'),
        globalSearch: this.getValueFromLocalStorage('dataListGlobalSearch')
      };
    }
  }]);

  return DataList;
}(_react.default.Component);

DataList.defaultProps = {
  initialPageLength: 10,
  pageLengthOptions: [5, 10, 20],
  showPageSize: true,
  filters: {
    globalSearch: {
      filter: containsIgnoreCase
    }
  },
  // When 'false' it also implicitly means that all rows will be displayed (ignoring pageSize).
  withControls: true,
  enableSort: true,
  showSearch: true,
  useLocalStorage: false
};
DataList.propTypes = {
  initialData: _propTypes.default.array,
  withControls: _propTypes.default.bool,
  staticTexts: _propTypes.default.shape({
    search: _propTypes.default.string,
    pageSize: _propTypes.default.string,
    noData: _propTypes.default.string,
    loading: _propTypes.default.string,
    all: _propTypes.default.string
  }),
  enableSort: _propTypes.default.bool,
  showPageSize: _propTypes.default.bool,
  filters: _propTypes.default.object,
  pageLengthOptions: _propTypes.default.array,
  columns: _propTypes.default.array,
  keys: _propTypes.default.array,
  buildRowOptions: _propTypes.default.func,
  isLoading: _propTypes.default.bool,
  showSearch: _propTypes.default.bool,
  loadData: _propTypes.default.func,
  useLocalStorage: _propTypes.default.bool
};
var _default = DataList;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/datalist/index.js
// module id = 29
// module chunks = 0